function unwrapShopifyBlockWrappers(wrapperEl) {
  Array.prototype.slice.call(wrapperEl.children).forEach(function (child) {
    if (child.classList && child.classList.contains('shopify-block')) {
      while (child.firstChild) {
        wrapperEl.insertBefore(child.firstChild, child);
      }
      wrapperEl.removeChild(child);
    }
  });
}

function initNewLandingBigBikeSlider(root) {
  if (typeof Swiper === 'undefined') return;

  var scope = root && root.querySelectorAll ? root : document;
  var groups = scope.querySelectorAll('.new-landing-big-bike-slider__group');

  groups.forEach(function (group) {
    if (group.dataset.bikeSliderInitialized) return;
    group.dataset.bikeSliderInitialized = 'true';

    var stageEl = group.querySelector('[data-bike-stage]');
    var wrapperEl = stageEl ? stageEl.querySelector('.swiper-wrapper') : null;
    var swatchesContainer = group.querySelector('[data-bike-swatches]');
    var atcEl = group.querySelector('[data-bike-atc]');
    var atcInput = group.querySelector('[data-bike-atc-input]');
    var atcButton = group.querySelector('[data-bike-atc-button]');
    var atcLabel = group.querySelector('[data-bike-atc-label]');
    var activeLabel = group.querySelector('[data-bike-active-label]');
    var switchEl = group.querySelector('[data-bike-switch]');
    var switchLabel = group.querySelector('[data-bike-switch-label]');
    var headingImageDesktop = group.querySelector('.new-landing-big-bike-slider__heading-image--desktop');
    var headingImageMobile = group.querySelector('.new-landing-big-bike-slider__heading-image--mobile');

    if (!stageEl || !wrapperEl) return;

    ['--stage-margin-top-desktop', '--stage-margin-top-mobile'].forEach(function (property) {
      var value = stageEl.style.getPropertyValue(property).trim();
      if (/^-?(?:\d+\.?\d*|\.\d+)$/.test(value)) {
        stageEl.style.setProperty(property, value + 'px');
      }
    });

    unwrapShopifyBlockWrappers(wrapperEl);

    var realSlideKeys = Array.prototype.map.call(wrapperEl.querySelectorAll('.swiper-slide'), function (el) {
      return el.dataset.slideKey;
    });

    var swatches = group.querySelectorAll('[data-slide-swatch]');
    if (swatchesContainer) {
      swatches.forEach(function (btn) {
        swatchesContainer.appendChild(btn);
      });
    }

    var swiper = new Swiper(stageEl, {
      slidesPerView: 1,
      autoHeight: true,
    });

    wrapperEl.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        swiper.updateAutoHeight();
      });
    });

    function normalizeBackgroundCss(value) {
      if (!value) return '';
      var nonBreakingSpace = String.fromCharCode(160);
      var normalSpace = String.fromCharCode(32);
      var withoutNbsp = value.split(nonBreakingSpace).join(normalSpace);
      return withoutNbsp.replace(/;\s*$/, '').trim();
    }

    var currentBgCss = '';

    function crossfadeBackground(bgCss) {
      if (!bgCss || bgCss === currentBgCss) return;

      var bgEl = group.querySelector('.new-landing-big-bike-slider__background');
      var fadeEl = group.querySelector('[data-bg-fade]');
      if (!bgEl || !fadeEl) return;

      currentBgCss = bgCss;
      fadeEl.style.transition = 'none';
      fadeEl.style.opacity = '0';
      fadeEl.style.setProperty('background', bgCss, 'important');

      // Force layout so the browser registers opacity: 0 before animating to 1.
      // eslint-disable-next-line no-unused-expressions
      fadeEl.offsetHeight;
      fadeEl.style.transition = '';

      requestAnimationFrame(function () {
        fadeEl.style.opacity = '1';
      });

      fadeEl.addEventListener('transitionend', function handler() {
        fadeEl.removeEventListener('transitionend', handler);
        bgEl.style.setProperty('background', bgCss, 'important');
        fadeEl.style.transition = 'none';
        fadeEl.style.opacity = '0';
        fadeEl.offsetHeight;
        fadeEl.style.transition = '';
      });
    }

    function applySwitchState(isOn) {
      if (switchEl) {
        switchEl.classList.toggle('is-active', isOn);
        switchEl.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      }

      if (switchLabel && switchEl) {
        switchLabel.textContent = isOn ? switchEl.dataset.nameOn : switchEl.dataset.nameOff;
      }

      var activeType = isOn ? 'type_2' : 'type_1';
      swatches.forEach(function (btn) {
        btn.style.display = btn.dataset.swatchType === activeType ? '' : 'none';
      });
    }

    function updateActiveState() {
      var activeSlide = wrapperEl.querySelector('.swiper-slide-active');
      var key = activeSlide ? activeSlide.dataset.slideKey : null;

      swatches.forEach(function (btn) {
        var selected = btn.dataset.slideKey === key;
        btn.classList.toggle('is-active', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (switchEl && key) {
        var selectedSwatch = Array.prototype.find.call(swatches, function (btn) {
          return btn.dataset.slideKey === key;
        });
        if (selectedSwatch) applySwitchState(selectedSwatch.dataset.swatchType === 'type_2');
      }

      if (activeLabel) {
        activeLabel.textContent = activeSlide ? (activeSlide.getAttribute('data-bike-name') || '') : '';
      }

      if (atcEl && atcInput && atcButton) {
        var variantId = activeSlide ? activeSlide.getAttribute('data-variant-id') : '';
        var variantAvailable = activeSlide ? activeSlide.getAttribute('data-variant-available') : '';

        if (variantId) {
          atcEl.hidden = false;
          atcInput.value = variantId;

          if (variantAvailable === 'false') {
            atcButton.disabled = true;
            if (atcLabel) atcLabel.textContent = 'Sold Out';
          } else {
            atcButton.disabled = false;
            if (atcLabel) atcLabel.textContent = 'Add to Cart';
          }
        } else {
          atcEl.hidden = true;
        }
      }

      var bgCss = normalizeBackgroundCss(activeSlide ? activeSlide.getAttribute('data-bg-css') : '');
      crossfadeBackground(bgCss);

      var logoUrl = activeSlide ? activeSlide.getAttribute('data-logo') : '';
      if (logoUrl) {
        if (headingImageDesktop) headingImageDesktop.src = logoUrl;
        if (headingImageMobile) headingImageMobile.src = logoUrl;
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.style.display === 'none') return;
        var index = realSlideKeys.indexOf(btn.dataset.slideKey);
        if (index !== -1) {
          swiper.slideTo(index);
          updateActiveState();
        }
      });
    });

    if (switchEl) {
      switchEl.addEventListener('click', function () {
        var turningOn = !switchEl.classList.contains('is-active');
        var targetType = turningOn ? 'type_2' : 'type_1';
        var activeSlide = wrapperEl.querySelector('.swiper-slide-active');
        var selectedSwatch = activeSlide ? Array.prototype.find.call(swatches, function (btn) {
          return btn.dataset.slideKey === activeSlide.dataset.slideKey;
        }) : null;

        var targetSwatch = Array.prototype.find.call(swatches, function (btn) {
          return btn.dataset.swatchType === targetType && selectedSwatch && btn.dataset.colorKey === selectedSwatch.dataset.colorKey;
        });
        if (!targetSwatch) {
          targetSwatch = Array.prototype.find.call(swatches, function (btn) {
            return btn.dataset.swatchType === targetType;
          });
        }

        if (targetSwatch) {
          var index = realSlideKeys.indexOf(targetSwatch.dataset.slideKey);
          if (index !== -1) {
            swiper.slideTo(index);
            updateActiveState();
          }
        }
      });
    }

    document.addEventListener('shopify:block:select', function (event) {
      if (!group.isConnected || !event.detail || !event.detail.blockId) return;
      var selectedId = event.detail.blockId.split('__').pop();
      var index = realSlideKeys.findIndex(function (key) {
        return key.split('__').pop() === selectedId;
      });
      if (index !== -1) {
        swiper.slideTo(index, 0);
        updateActiveState();
      }
    });

    swiper.on('slideChange', updateActiveState);
    swiper.on('slideChangeTransitionEnd', updateActiveState);
    updateActiveState();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initNewLandingBigBikeSlider(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initNewLandingBigBikeSlider(event.target);
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initNewLandingBigBikeSlider(document);
}
